import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { postGroupData } from '../../service/adminApi';
import { useNavigate } from 'react-router-dom';

function CreateGroup() {
    const initialGroup = {
        name: '',
        description: '',
        employee: [],
        group_status: false,
        is_admin: false,
    };

    const navigate = useNavigate();

    const defaultValue = {
        1: {
            readAccess: true,
            writeAccess: false,
            approveAccess: false,
        },
        2: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        3: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        4: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        5: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        6: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        7: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        8: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        9: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        10: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        11: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        12: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        13: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        14: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        15: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        16: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        17: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        18: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
        19: {
            readAccess: false,
            writeAccess: false,
            approveAccess: false,
        },
    };

    const [groupDetails, setGroupDetails] = React.useState(initialGroup);
    const [checkedData, setCheckedData] = React.useState(defaultValue);
    const [user, setUser] = React.useState('');
    const [flag, setFlag] = React.useState(false);

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (e.target.name === 'is_admin') {
            setGroupDetails((groupDetails) => ({
                ...groupDetails,
                [e.target.name]: !groupDetails.is_admin,
            }));
        } else if (e.target.name === 'group_status') {
            setGroupDetails((groupDetails) => ({
                ...groupDetails,
                [e.target.name]: !groupDetails.group_status,
            }));
        } else {
            setGroupDetails((groupDetails) => ({
                ...groupDetails,
                [e.target.name]: value,
            }));
        }
    };

    const insertGroupDetails = async () => {
        let data = {
            ...groupDetails,
            services: checkedData,
        };
        const response = await postGroupData(data);
        if (response.data.statusCode === 200) {
            navigate('/admin/usermanagement');
        }
    };

    const onCheckBoxChange = (e, category, type) => {
        setCheckedData((prev) => {
            return {
                ...prev,
                [category]: {
                    ...prev[category],
                    [type]: e.target.checked,
                },
            };
        });
    };

    const isCategoryChecked = (category, type) => {
        return checkedData[category][type];
    };

    const handleUserChange = (e) => {
        // 

        if (e.keyCode == 13) {
            let groupDetail = groupDetails;
            let arr = groupDetail.employee;
            arr.push(user);
            groupDetail['employee'] = arr;
            setGroupDetails(groupDetail);
            setFlag(!flag);
            setUser('');
        }
    };

    {

    }
    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs />
            <div className="admin-panel-bg p-3">
                <h5 className="bold-text tt-bold font-18">Create Group</h5>
                <div className="row">
                    <div className="mb-3 col-md-6 mt-3">
                        <label htmlFor="groupname" className="form-label hive-form-label">
                            Group Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control hive-form-control admin-group-control"
                            id="groupname"
                            name="name"
                            placeholder="Enter Group Name"
                            value={groupDetails.name}
                            onChange={(e) => {
                                handleInputChange(e);
                            }}
                        />
                    </div>
                    <div className="mb-3 col-md-2 mt-3">
                        <label htmlFor="groupstatus" className="form-label hive-form-label">
                            Group Status <span className="required">*</span>
                        </label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="groupstatus"
                                name="group_status"
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                    </div>
                    <div className="mb-3 col-md-2 mt-3">
                        <label htmlFor="Isadmin" className="form-label hive-form-label">
                            Is Admin? <span className="required">*</span>
                        </label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="Isadmin"
                                name="is_admin"
                                onChange={(e) => handleInputChange(e)}
                            />
                        </div>
                    </div>
                    <div className="mb-5 col-md-10 mt-3">
                        <label htmlFor="groupdescription" className="form-label hive-form-label">
                            Group Description <span className="required">*</span>
                        </label>
                        <textarea
                            className="form-control hive-form-control admin-group-control resize-none"
                            placeholder="Provide a description for the group"
                            id="groupdescription"
                            name="description"
                            value={groupDetails.description}
                            onChange={(e) => {
                                handleInputChange(e);
                            }}
                        />
                    </div>
                </div>
                <div className="accordion" id="accordionExample">
                    <div className="accordion-item border-0 accordian-table-sty">
                        <h2 className="accordion-header mb-2 px-0 admin-entitlement-border-line" id="goalevaluation">
                            <button
                                className="admin-entitle-accordion-button border-0 white-bg pb-3 bold-text font-15"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                Users <span>(10)</span>
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="goalevaluation"
                            data-bs-parent="#accordionExample"
                        >
                            <div className="accordion-body px-0">
                                <div className="accordion" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item border-0 accordian-table-sty">
                                        <div
                                            id="panelsStayOpen-collapseOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="panelsStayOpen-headingOne"
                                        >
                                            <div className="accordion-body pt-0 px-0">
                                                <div className="row">
                                                    <div className="mb-3 col-md-8">
                                                        <label htmlFor="exampleInputEmail1" className="form-label hive-form-label">
                                                            Add Users <span className="required">*</span>
                                                        </label>
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control hive-form-control"
                                                                    id="exampleInputEmail1"
                                                                    placeholder="Enter Username"
                                                                    name="add_users"
                                                                    onKeyDown={(e) => {
                                                                        handleUserChange(e);
                                                                    }}
                                                                    value={user}
                                                                    onChange={(e) => {
                                                                        setUser(e.target.value);
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-md-5">
                                                                <button
                                                                    className="btn hive-btn-primary bold-text font-12 ms-5"
                                                                    type="button"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#MyPopup"
                                                                >
                                                                    <img className="me-2" src="/Images/plus.svg" />
                                                                    Add Multiple Users
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mb-3 col-md-3">
                                                        <div
                                                            className="modal fade"
                                                            id="MyPopup"
                                                            tabIndex={-1}
                                                            aria-labelledby="exampleModalLabel"
                                                            aria-hidden="true"
                                                        >
                                                            <div className="modal-dialog feedback-popup modal-dialog-centered border-0 ">
                                                                <div className="modal-content">
                                                                    <div className="modal-header border-0">
                                                                        <h5
                                                                            className="modal-title font-18 semibold-text feedback-head-clr"
                                                                            id="exampleModalLabel"
                                                                        >
                                                                            Add Multiple Users
                                                                        </h5>
                                                                        <button
                                                                            type="button"
                                                                            className="btn-close"
                                                                            data-bs-dismiss="modal"
                                                                            aria-label="Close"
                                                                        />
                                                                    </div>
                                                                    <div className="modal-body pt-2 pb-1">
                                                                        <div className="row mb-4">
                                                                            <div className="col-md-12">
                                                                                <label className="medium-text w-100 mb-3">
                                                                                    Use template to add multiple users
                                                                                </label>
                                                                                <a
                                                                                    href="#"
                                                                                    className="anchor-text font-15 text-decoration-none"
                                                                                >
                                                                                    <img src="/Images/excel.svg" alt="text" /> Download
                                                                                    Template
                                                                                </a>
                                                                            </div>
                                                                            <div className="mt-4">
                                                                                <label
                                                                                    htmlFor="voterid-upload"
                                                                                    className="custom-file-upload-styles"
                                                                                >
                                                                                    <img
                                                                                        className="me-2"
                                                                                        src="/Images/top-up.svg"
                                                                                        alt="Upload Icon"
                                                                                    />
                                                                                    Upload
                                                                                </label>
                                                                                <input
                                                                                    id="voterid-upload"
                                                                                    className="custom-file-upload-btn"
                                                                                    type="file"
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-12 justify-content-end d-flex">
                                                                                <button className="btn hive-btn-secondary me-3">
                                                                                    Cancel
                                                                                </button>
                                                                                <button
                                                                                    // onClick={() => {
                                                                                    //     insertGroupDetails();
                                                                                    // }}
                                                                                    className="btn hive-btn-primary"
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-3 mb-3">
                                                        <div className="d-flex admin-entitlement-remove">
                                                            <img src="/Images/logo-person-user-person-icon.jpg" className="admin-entitle-table-image" />
                                                            <div className="ms-3">
                                                                <a href="#" className="admin-entitle-table-name semibold-text mb-0">
                                                                    Gokula Krishnan
                                                                </a>
                                                                <p className="admin-entitle-table-domain mb-0 font-13 regular-text">
                                                                    HR Manager
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <div className="d-flex admin-entitlement-remove">
                                                            <img src="/Images/logo-person-user-person-icon.jpg" className="admin-entitle-table-image" />
                                                            <div className="ms-3">
                                                                <a href="#" className="admin-entitle-table-name semibold-text mb-0">
                                                                    Gokula Krishnan
                                                                </a>
                                                                <p className="admin-entitle-table-domain regular-text font-13 mb-0">
                                                                    HR Manager
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Accordion ends*/}
                <div className="accordion" id="accordionExample">
                    <div className="accordion-item border-0 accordian-table-sty">
                        <h2 className="accordion-header mb-2 px-0 admin-entitlement-border-line" id="goalevaluation">
                            <button
                                className="admin-entitle-accordion-button border-0 bg-white pb-3 bold-text font-15"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                Service Level
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse"
                            aria-labelledby="goalevaluation"
                            data-bs-parent="#accordionExample"
                        >
                            <div className="accordion-body px-0">
                                <div className="accordion" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item border-0 accordian-table-sty">
                                        <div
                                            id="panelsStayOpen-collapseOne"
                                            className="accordion-collapse collapse show"
                                            aria-labelledby="panelsStayOpen-headingOne"
                                        >
                                            <div className="accordion-body pt-0 px-0 mb-5">
                                                <table className="admin-entitle-table-services w-100 mb-3">
                                                    <thead>
                                                        <tr className="border-bottom">
                                                            <th>Services</th>
                                                            <th className="text-center">Read</th>
                                                            <th className="text-center">Write</th>
                                                            <th className="text-center">Approve</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="border-table-row">
                                                            <td className="semibold-text" colSpan={4}>
                                                                Dashboard
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">HR Statistics</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrStatistics_read"
                                                                    checked={isCategoryChecked('1', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '1', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrStatistics_write"
                                                                    checked={isCategoryChecked('1', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '1', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrStatistics_approve"
                                                                    checked={isCategoryChecked('1', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '1', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom">
                                                            <td className="regular-text font-14 ps-5">HR Activities</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrActivities_read"
                                                                    checked={isCategoryChecked('2', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '2', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrActivities_write"
                                                                    checked={isCategoryChecked('2', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '2', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    name="hrActivities_approve"
                                                                    checked={isCategoryChecked('2', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '2', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom">
                                                            <td className="semibold-text">Todo</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="todo_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('3', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '3', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="todo_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('3', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '3', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="todo_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('3', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '3', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom">
                                                            <td className="semibold-text">Leave</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="leave_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('4', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '4', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="leave_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('4', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '4', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="leave_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('4', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '4', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-table-row">
                                                            <td className="semibold-text" colSpan={4}>
                                                                Employee
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Performance</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="performance_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('5', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '5', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="performance_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('5', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '5', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    name="performance_approve"
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('5', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '5', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Touchbase</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="touchbase_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('6', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '6', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="touchbase_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('6', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '6', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="touchbase_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('6', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '6', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Employee Directory</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeedirectory_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('7', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '7', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeedirectory_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('7', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '7', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeedirectory_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('7', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '7', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Goal Template</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="goaltemplate_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('8', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '8', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="goaltemplate_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('8', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '8', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="goaltemplate_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('8', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '8', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Employee Mood</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeemood_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('9', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '9', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeemood_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('9', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '9', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeemood_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('9', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '9', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Employee Concerns</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeeconerns_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('10', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '10', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeeconerns_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('10', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '10', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="employeeconerns_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('10', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '10', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Profile Update</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="profileupdate_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('11', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '11', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="profileupdate_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('11', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '11', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="profileupdate_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('11', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '11', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Appreciation</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="appreciation_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('12', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '12', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="appreciation_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('12', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '12', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="appreciation_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('12', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '12', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom">
                                                            <td className="regular-text font-14 ps-5">Off - Boarding</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="offboarding_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('13', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '13', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="offboarding_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('13', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '13', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="offboarding_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('13', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '13', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-table-row">
                                                            <td className="semibold-text" colSpan={4}>
                                                                How do I?
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14  ps-5">Policy List</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="policylist_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('14', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '14', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="policylist_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('14', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '14', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="policylist_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('14', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '14', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-bottom">
                                                            <td className="regular-text font-14  ps-5">FAQ</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="faq_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('15', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '15', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="faq_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('15', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '15', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="faq_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('15', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '15', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr className="border-table-row">
                                                            <td className="semibold-text" colSpan={4}>
                                                                Recruitment
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Job Request</td>
                                                            <td className="text-center">
                                                                <input
                                                                    name="jobrequest_read"
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('16', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '16', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="jobrequest_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('16', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '16', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="jobrequest_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('16', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '16', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Interview Template</td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="interviewtemplate_read"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('17', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '17', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="interviewtemplate_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('17', 'writeAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '17', 'writeAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="interviewtemplate_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('17', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '17', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="regular-text font-14 ps-5">Onboarding</td>
                                                            <td className="text-center">
                                                                <input
                                                                    name="onboarding_read"
                                                                    type="checkbox"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('18', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '18', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="onboarding_write"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('18', 'readAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '18', 'readAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="onboarding_approve"
                                                                    className="form-check-input hive-form-check-input admin-input-check"
                                                                    checked={isCategoryChecked('18', 'approveAccess')}
                                                                    onChange={(e) => {
                                                                        onCheckBoxChange(e, '18', 'approveAccess');
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="float-end me-5 ">
                                                    <button className="btn cancel-button bold-text font-13 me-4">Cancel</button>
                                                    <button
                                                        onClick={() => {
                                                            insertGroupDetails();
                                                        }}
                                                        className="btn medium-text font-12 primary-button "
                                                    >
                                                        Create
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Accordion ends*/}
                </div>
            </div>
        </div>
    );
}

export default CreateGroup;
